<template>
    <section>
        <swiper :options="swiperOption" ref="previewSwiper">
            <swiper-slide v-for="(slide, index) in previewData.slide.files" :key="index">
                <div>
                    <img :src="slide" alt="">
                    
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div> 
        </swiper>
        
    </section>
</template>

<script>
/**
 * 이미지 슬라이드 강의 미리보기 컴포넌트(image slide lesson preview component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Vue from 'vue'

export default {
    props: ['previewData', 'orientationMode'],
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 16,
                
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true


                },
                translate: 0,
                autoHeight: false,
                
            },
        }
        
    },

    
    computed: {
        swiper() {
            return this.$refs.previewSwiper.swiper
        },
    },
}
</script>